var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbh-readonly-quill"},[_c('quill-editor',{attrs:{"options":_vm.op,"disabled":true,"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }